import {
  LOCATIONS_ALL_SUCCESS
} from '../actions/locations'

export default function (state = [], action) {
  switch (action.type) {
    case LOCATIONS_ALL_SUCCESS:
      return action.payload.locations

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/all-locations.js